
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyRadio as SkyRadioElement, SkyRadioSelectDetail, SkyRadioValidationErrorDetail, SkyRadioValueClearedDetail } from '@sky.ui/core/sky-radio';
 
 

 
 export const SkyRadio = createComponent({
   displayName: 'SkyRadio',
   react: React,
   tagName: 'sky-radio',
   elementClass: SkyRadioElement,
   events: {
     
     onRadioSelect: 'radio-select' as EventName<CustomEvent<SkyRadioSelectDetail>>,
     onChange: 'change' as EventName<Event>,
     onInput: 'input' as EventName<Event>,
     onValidationError: 'validation-error' as EventName<CustomEvent<SkyRadioValidationErrorDetail>>,
     onValueCleared: 'value-cleared' as EventName<CustomEvent<SkyRadioValueClearedDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-radio';
